// Canonical SKU literals for every product sold on the storefront. Import
// from here instead of retyping the raw string so a SKU only lives in one
// place — values are plain strings so they compare directly against SKUs
// coming back from Shopify, Contentful, and URL params without casting.
export const PRODUCT_SKUS = {
  DAILY_SYNBIOTIC: 'syn-wk',
  DAILY_SYNBIOTIC_3MO: 'syn-wk-3mo',
  DAILY_SYNBIOTIC_6MO: 'syn-wk-6mo',
  DAILY_SYNBIOTIC_ONE_TIME: 'syn-wk-otp',
  DAILY_SYNBIOTIC_REFILL: 'syn-rf',
  DAILY_SYNBIOTIC_REFILL_2MO: 'syn-rf-2mo',
  DAILY_SYNBIOTIC_REFILL_3MO: 'syn-rf-3mo',
  DAILY_SYNBIOTIC_REFILL_6MO: 'syn-rf-6mo',
  DAILY_SYNBIOTIC_REFILL_12MO: 'syn-rf-12mo',
  ENERGY_FOCUS: 'am-wk',
  ENERGY_FOCUS_3MO: 'am-wk-3mo',
  ENERGY_FOCUS_REFILL: 'am-rf',
  ENERGY_FOCUS_REFILL_3MO: 'am-rf-3mo',
  SLEEP_RESTORE: 'pm-wk',
  SLEEP_RESTORE_3MO: 'pm-wk-3mo',
  SLEEP_RESTORE_REFILL: 'pm-rf',
  SLEEP_RESTORE_REFILL_3MO: 'pm-rf-3mo',
  GUT_RESET: 'syn-gr',
  DAILY_MULTIVITAMIN: 'dm-wk',
  DAILY_MULTIVITAMIN_3MO: 'dm-wk-3mo',
  DAILY_MULTIVITAMIN_REFILL: 'dm-rf',
  DAILY_MULTIVITAMIN_REFILL_3MO: 'dm-rf-3mo',
  VAGINAL_SYNBIOTIC: 'vs-wk',
  VAGINAL_SYNBIOTIC_SUSTAIN: 'vs-rf',
  PDS08_DAILY_KIDS_PROBIOTIC: 'pds-wk',
  PDS08_DAILY_KIDS_PROBIOTIC_REFILL: 'pds-rf',
} as const;

export type ProductSku = (typeof PRODUCT_SKUS)[keyof typeof PRODUCT_SKUS];

// The Duo's ID in Meta's catalog. Not a Shopify SKU — the Duo is sold as
// DS-01 + DM-02 line items — so it stays out of PRODUCT_SKUS.
export const META_DUO_SKU = 'daily-essentials-duo';
